export default __webpack_public_path__ + "assets/tilemaps/sallowfen_inn_level_2.json";